import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen grid place-items-center bg-slate-50 px-6" data-testid="error-boundary">
          <div className="max-w-md text-center">
            <div className="text-4xl mb-3">⚠️</div>
            <h1 className="font-heading text-2xl font-semibold text-slate-900">Something went wrong</h1>
            <p className="text-sm text-slate-500 mt-2">
              An unexpected error occurred while rendering this page. Try reloading.
            </p>
            <pre className="mt-4 text-xs text-left bg-white border border-slate-200 rounded p-3 overflow-x-auto text-red-700">
              {String(this.state.error?.message || this.state.error || "Unknown error")}
            </pre>
            <div className="mt-5 flex gap-2 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 rounded-md bg-brand hover:bg-brand-dark text-white text-sm font-medium"
                data-testid="error-boundary-reload"
              >
                Reload page
              </button>
              <button
                onClick={this.reset}
                className="px-4 py-2 rounded-md border border-slate-200 text-slate-700 text-sm font-medium hover:bg-slate-50"
                data-testid="error-boundary-dismiss"
              >
                Try again
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
